import { ErrorDialogService } from "../services/error-dialog/error-dialog.service";
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";

export const errorDialogInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const errorDialogService = inject(ErrorDialogService);

  // Pass the request along, watching for a failure
  return next(req).pipe(
    catchError((error: unknown) => {
      // Offer the failure to the error dialog, then rethrow for the caller
      errorDialogService.handleHttpError(req, error);
      return throwError(() => error);
    }),
  );
};
